// extracted by mini-css-extract-plugin
export var closeButton = "_l1-2";
export var closeButtonIcon = "_l1-3";
export var lightboxContent = "_l1-1";
export var lightboxOverlay = "_l1-0";